import AdminCabinet from './AdminCabinet';

export default AdminCabinet;
